import { IconBase, IconBaseProps } from "./IconBase";

export const CheckIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="16 10 11 15 8 12" />
  </IconBase>
);
